<oiq-ui-dropdown #dropdownRef="OiqUiDropdown" [overlayPositions]="overlayPositions">
  <button
    class="rounded-lg px-1 pt-1 text-gray-6"
    type="button"
    id="notifications"
    cdkOverlayOrigin
    (click)="dropdownRef.toggle()">
    <span class="material-icons" [oiqUiBadge]="badgeCount$ | async" badgeVariant="warning"
      >notifications</span
    >
  </button>
  <ng-template #dropdownTemplate>
    <oiq-notification-events
      class="block min-w-[40rem]"
      (event)="handleNotification($event)"></oiq-notification-events>
  </ng-template>
</oiq-ui-dropdown>
